import BaseStore from './BaseStore'

export class GroupStore extends BaseStore {
  constructor() {
    super()
    this.endpoint = 'groups'
  }
}

export default new GroupStore()


// WEBPACK FOOTER //
// ./src/stores/GroupStore.js